import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { Download, FileText } from "lucide-react";

export default function ExportDialog({ onExport }) {
  const [open, setOpen] = useState(false);
  const [format, setFormat] = useState("markdown");
  const [exporting, setExporting] = useState(false);

  const handleExport = async () => {
    setExporting(true);
    try {
      await onExport?.(format);
    } finally {
      setExporting(false);
    }
    setOpen(false);
  };

  return (
    <>
      <Button onClick={() => setOpen(true)} variant="outline" size="sm">
        <Download className="w-4 h-4 mr-1" />
        Export
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-sm">
          <DialogHeader>
            <DialogTitle className="text-lg flex items-center gap-2">
              <FileText className="w-5 h-5 text-violet-500" />
              Export Meeting
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <Label className="text-xs text-slate-600">Format</Label>
              <Select value={format} onValueChange={setFormat}>
                <SelectTrigger className="mt-1">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="markdown">Markdown (Meeting Minutes)</SelectItem>
                  <SelectItem value="json">JSON (Structured Data)</SelectItem>
                </SelectContent>
              </Select>
            </div>
            {format === "markdown" && (
              <p className="text-xs text-slate-400">
                Generates formatted meeting minutes with overview, key points, decisions, and action items.
              </p>
            )}
            {format === "json" && (
              <p className="text-xs text-slate-400">
                Exports raw session data as structured JSON for programmatic use.
              </p>
            )}
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Cancel</Button>
            <Button onClick={handleExport} disabled={exporting} className="bg-violet-600 hover:bg-violet-700">
              {exporting ? "Exporting..." : "Export"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
